<template>
  <div>
    <!--    版本选择-->
    <TipDialog
      :data="list"
      :visible="versionVisible"
      :is-disable="quotationList.customConfig"
      @close="cancel"
      @confirm="handelVersionChange"
    />

    <!--    自定义报价重算-->
    <RecalculateDialog
      :visible="recalculateVisible"
      :quotation-list="quotationList"
      @close="recalculateCancel"
      @confirm="handelRecalculateChange"
    />
  </div>
</template>

<script>
import RecalculateDialog from './recalculateDialog.vue';
import TipDialog from './tipDialog.vue';

export default {
  components: { TipDialog, RecalculateDialog },

  props: {
    // 是否展示自定义版本弹窗
    visible: {
      type: Boolean,
      default: false
    },
    // 导入数据
    list: {
      type: Array,
      default: () => []
    },
    // 查询报价数据
    quotationList: {
      type: Object,
      default: () => ({
        customConfig: false
      })
    }
  },

  data() {
    return {
      versionVisible: false, // 版本弹窗
      recalculateVisible: false // 报价弹窗
    };
  },

  watch: {
    // 监听父组件的visible属性 更新版本弹窗
    visible: {
      handler(val) {
        if (val) {
          // 打开弹窗时，重置内部状态并显示
          this.versionVisible = true;
          this.recalculateVisible = false;
        } else {
          // 关闭弹窗时，重置所有内部状态
          this.versionVisible = false;
          this.recalculateVisible = false;
        }
      },
      immediate: false
    }
  },

  methods: {
    cancel() {
      // 关闭导入版本弹窗
      this.versionVisible = false;
      this.$emit('close');
    },
    // 关闭报价弹窗
    recalculateCancel() {
      this.cancel();
      this.recalculateVisible = false;
    },
    // 版本选择
    // type 1: 默认重算 2: 指定报价重算
    handelVersionChange(obj) {
      console.log(obj);
      const { versionType } = obj;
      if (versionType === 1) {
        this.$emit('confirm', { data: this.list });
      } else {
        console.log('指定版本重算');
        // 打开报价重算弹窗
        // this.$emit('close');
        this.versionVisible = false;
        this.recalculateVisible = true;
      }
    },
    // 指定报价重算
    handelRecalculateChange(row) {
      console.log(row, '选择报价版本');
      this.$emit('confirm', {
        data: this.list,
        customVersionEnabled: true,
        customVersionOfferPriceId: row.id
      });
    }
  }
};
</script>

<style scoped>

</style>
